import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { InfoBlock } from 'components/Shared/InfoBlock';
import * as Styled from './styles';
import { CartStepEnum, useCartValues } from '../../providers/CartProvider';
import * as StyledShared from '../../styles';

export const CartCheckoutFail = memo(() => {
  const { t } = useTranslation();
  const { setCartStep, checkoutErrorMessage } = useCartValues();

  return (
    <StyledShared.CartContainer>
      <StyledShared.CartHeaderNavigation>
        <Styled.Close />
      </StyledShared.CartHeaderNavigation>
      <InfoBlock
        title={t('cart.checkoutFailTitle')}
        type="contrast"
        imageType="payment-fail"
        description={t('cart.checkoutFailDescription')}
        buttonProps={{
          onClick: () => setCartStep(CartStepEnum.Payment),
          text: t('cart.checkoutFailButtonText')
        }}
      />
      {checkoutErrorMessage && (
        <Styled.ErrorMessage
          dangerouslySetInnerHTML={{ __html: checkoutErrorMessage }}
        />
      )}
    </StyledShared.CartContainer>
  );
});
